import type { z } from "zod";
import { errorText, type Result } from "./result.ts";

export function parseJson(text: string): Result<unknown>;
export function parseJson<T>(text: string, schema: z.ZodType<T>): Result<T>;
export function parseJson<T>(text: string, schema?: z.ZodType<T>): Result<unknown> {
  let json: unknown;
  try {
    json = JSON.parse(text);
  } catch (error) {
    return { ok: false, reason: `not JSON (${errorText(error)})` };
  }
  if (!schema) return { ok: true, value: json };
  const parsed = schema.safeParse(json);
  return parsed.success ? { ok: true, value: parsed.data } : { ok: false, reason: describeIssues(parsed.error.issues).join("; ") };
}

export function describeIssues(issues: z.ZodError["issues"], under: readonly PropertyKey[] = []): string[] {
  return issues.map((issue) => `${[...under, ...issue.path].join(".") || "(root)"}: ${issue.message}`);
}
